'use client';

import styles from './OffersAchievingList.module.scss';

export default function OffersAchievingList({ items }) {
  const getNavigationInfo = (item) => {
    if (!item) {
      return {
        type: 'internal',
        url: '#',
        text: 'view offer',
      };
    }

    const isComingSoon = item?.fields?.isComingSoon?.value || item?.isComingSoon || false;
    const isExternalLink = item?.fields?.isExternalLink?.value || item?.isExternalLink || false;
    const externalLink = item?.fields?.externalLink?.value || item?.externalLink || '';
    const buttonUrl = item?.fields?.buttonUrl?.value || item?.buttonUrl || {};
    const buttonText = item?.fields?.buttonText?.value || item?.buttonText || 'view offer';

    if (isComingSoon) {
      return {
        type: 'coming-soon',
        url: '#',
        text: buttonText,
      };
    }

    if (isExternalLink && externalLink) {
      return {
        type: 'external',
        url: externalLink,
        text: buttonText,
      };
    }

    return {
      type: 'internal',
      url: buttonUrl?.href || item?.url || '#',
      text: buttonText,
    };
  };

  // 安全检查items
  if (!items || !Array.isArray(items)) {
    return <div>No items available</div>;
  }

  return (
    <ul className={styles.list}>
      {items.map((item, index) => {
        // 安全检查item
        if (!item) {
          return null;
        }

        const itemTitle =
          item?.fields?.title?.value ||
          item?.title ||
          item?.name ||
          item?.displayName ||
          'Untitled';
        const itemImage = item?.fields?.image || item?.image;
        const navInfo = getNavigationInfo(item);

        const hasValidImage =
          itemImage &&
          (itemImage.fields?.desktopImage?.value?.src ||
            itemImage.fields?.tabletImage?.value?.src ||
            itemImage.fields?.mobileImage?.value?.src);

        const imageSrc =
          itemImage?.fields?.desktopImage?.value?.src ||
          itemImage?.fields?.tabletImage?.value?.src ||
          itemImage?.fields?.mobileImage?.value?.src ||
          '';

        return (
          <li className={styles.card} key={item.id || `item-${index}`} data-aos="fade-up">
            {hasValidImage ? (
              <img src={imageSrc} alt={itemTitle} />
            ) : (
              <div
                style={{
                  width: '100%',
                  height: '340px',
                  backgroundColor: '#f0f0f0',
                  borderRadius: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#666',
                  fontSize: '14px',
                }}
              >
                No Image
              </div>
            )}

            <div className={styles.card_content}>
              <h2 className={styles.card_content_title}>{itemTitle}</h2>
              {navInfo.type === 'coming-soon' ? (
                <button className={styles.comingSoon}>{navInfo.text}</button>
              ) : (
                <a
                  className={styles.card_content_buttonPC}
                  href={navInfo.url}
                  target={navInfo.type === 'external' ? '_blank' : '_self'}
                  rel={navInfo.type === 'external' ? 'noopener noreferrer' : ''}
                >
                  {navInfo.text}
                </a>
              )}
            </div>

            {navInfo.type === 'coming-soon' ? (
              <button className={styles.comingSoonMobile}>{navInfo.text}</button>
            ) : (
              <a
                className={styles.card_content_buttonLaptop}
                href={navInfo.url}
                target={navInfo.type === 'external' ? '_blank' : '_self'}
                rel={navInfo.type === 'external' ? 'noopener noreferrer' : ''}
              >
                {navInfo.text}
              </a>
            )}
          </li>
        );
      })}
    </ul>
  );
}
